export default function documentLabelDisplay(cpfcnpj) {
  return cpfcnpj && cpfcnpj.length > 11 ? "CNPJ" : "CPF";
}
